import { tool } from "@openai/agents/realtime";
import { getSlots } from "./calcom";

export const calcomTools = [
  tool({
    name: "get_available_times",
    description: "Get available times for booking a meeting",
    execute: async () => {
      return await getSlots();
    },
    parameters: {
      type: "object",
      properties: {},
      required: [],
      additionalProperties: false,
    },
  }),

  tool({
    name: "book_meeting",
    description: "book the actual meeting for prospect",
    parameters: {
      type: "object",
      properties: {
        start: {
          type: "string",
          description: "The start time of the meeting in ISO string format",
        },
        email: {
          type: "string",
          description: "The email address of the prospect",
        },
      },
      required: ["start", "email"],
      additionalProperties: false,
    },
    execute: async (p) => {
      console.log("[bookmeeting]", JSON.stringify(p));
      return `Successs -  ${JSON.stringify(p)}`;
    },
  }),
];

export const informationTools = [
  tool({
    name: "record_meeting_summary",
    description: "Record Meeting Summary",
    execute: async (input) => {
      console.log("[informationTools]", JSON.stringify(input));
    },
    parameters: {
      type: "object",
      properties: {
        summary: {
          type: "string",
          description: "The summary of the meeting to record",
        },
      },
      required: ["summary"],
      additionalProperties: false,
    },
  }),
];
